<div class="filter-top-bar mt-0" #filterTopBar>
  <div class="filter-wrapper dropdown">
    <div class="d-flex justify-content-start align-items-center position-relative me-10">
      <input type="search" class="form-control table-search ps-35 pe-35 no-clear-button" placeholder="Enter your search term"
        [formControl]="searchFormControl" />
      <span class="position-absolute icon-search ps-10"></span>
      <button type="button" class="btn-close position-absolute end-0 me-10" aria-label="Clear" (click)="searchFormControl.setValue('')"
        *ngIf="searchFormControl.value">
      </button>
    </div>

    <div class="filter-tabs-holder" cdkDropList cdkDropListOrientation="horizontal" (cdkDropListDropped)="drop($event)" [cdkDropListConnectedTo]="[deleteArea]">
      <div *ngFor="let filter of filters" cdkDrag (cdkDragStarted)="isBeingDragged = true" (cdkDragEnded)="isBeingDragged = false">
        <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
        <div class="filter-tab" *ngIf="filter.show">
          <a cdkDragHandle class="dropdown-toggle d-flex justify-content-center align-items-center" role="button" id="filter-{{ filter.filterKey }}"
            data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside" [ngClass]="{'active': isFilterActive(filter)}">
            {{ filter.title }}
            <span *ngIf="getPeekForSelectedValues(filter) as peekValue">&nbsp;({{peekValue | truncate: 4}})</span>
          </a>

          <form [formGroup]="form">
            <div *ngIf="filter.filterKey === 'id'" class="dropdown-menu px-0 py-0_8 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="filter-{{ filter.filterKey }}">
              <div class="mx-10">
                <input type="text" formControlName="id" class="form-control input wider-input" placeholder="ID - separated by comma"
                  (keydown.enter)="onSubmitClick(filter.filterKey);$event.preventDefault()" />
                <input-errors [control]="form.controls.ids" [service]="validationService"></input-errors>
              </div>
              <hr>
              <div class="d-flex justify-content-end mx-10">
                <button class="btn mr-10" (click)="onClear(filter.filterKey)">Clear</button>
                <button class="btn btn-primary" (click)="onSubmitClick(filter.filterKey)">Submit</button>
              </div>
            </div>

            <div *ngIf="filter.filterKey === 'userEmail'" class="dropdown-menu px-0 py-15 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="fiter-{{ filter.filterKey }}">
              <div class="user-filter-drop">
                <app-users-select [multiple]="true" (clear)="onClear('schedulerUserIds')" (selectUser)="onSelectUser($event)"
                  (unSelectUser)="onUnSelectUser($event)"></app-users-select>
              </div>
            </div>

            <div *ngIf="filter.filterKey === 'status'" class="dropdown-menu px-0 py-15 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="filter-{{ filter.filterKey }}">
              <div class="mx-10">
                <div class="role-item d-flex justify-content-start align-items-center gap-10 my-10 cp" (click)="onChangeStatus('ACTIVE')">
                  <div class="input-check">
                    <input type="checkbox" class="form-check-input" [checked]="status.includes('ACTIVE')" />
                  </div>
                  <i class="far fa-check-circle fs-4 text-success-s2"></i>
                  <span>Active</span>
                </div>
                <div class="role-item d-flex justify-content-start align-items-center gap-10 my-10 cp" (click)="onChangeStatus('PENDING')">
                  <div class="input-check">
                    <input type="checkbox" class="form-check-input" [checked]="status.includes('PENDING')" />
                  </div>
                  <i class="far fa-times-circle fs-4 text-error-r3"></i>
                  <span>Pending</span>
                </div>
              </div>
            </div>

            <div *ngIf="filter.filterKey === 'paymentType'" class="dropdown-menu px-0 py-0_8 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="fiter-{{ filter.filterKey }}">
              <div class="mx-10">
                <div class="d-flex justify-content-start align-items-center gap-10 my-10 cp" (click)="onChangePaymentSelection('PREPAID')">
                  <div class="input-check">
                    <input type="checkbox" class="form-check-input" [checked]="paymentType.includes('PREPAID')" />
                  </div>
                  <span>Prepaid</span>
                </div>
                <div class="d-flex justify-content-start align-items-center gap-10 my-10 cp" (click)="onChangePaymentSelection('POSTPAID')">
                  <div class="input-check">
                    <input type="checkbox" class="form-check-input" [checked]="paymentType.includes('POSTPAID')" />
                  </div>
                  <span>Postpaid</span>
                </div>
              </div>
            </div>

            <div *ngIf="filter.filterKey === 'title'" class="dropdown-menu px-0 py-0_8 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="filter-{{ filter.filterKey }}">
              <div class="mx-10">
                <input type="text" formControlName="title" class="form-control input wider-input" placeholder="Title - separated by comma"
                  (keydown.enter)="onSubmitClick(filter.filterKey);$event.preventDefault()" />
                <input-errors [control]="form.controls.title" [service]="validationService"></input-errors>
              </div>
              <hr>
              <div class="d-flex justify-content-end mx-10">
                <button class="btn mr-10" (click)="onClear(filter.filterKey)">Clear</button>
                <button class="btn btn-primary" (click)="onSubmitClick(filter.filterKey)">Submit</button>
              </div>
            </div>

            <div *ngIf="filter.filterKey === 'serviceList'" class="dropdown-menu px-0 py-0_8 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="fiter-{{ filter.filterKey }}">
              <div class="mx-10">
                <div class="d-flex justify-content-start align-items-center gap-10 my-10 cp" (click)="onChangeProducts('MT')">
                  <div class="input-check">
                    <input type="checkbox" class="form-check-input" [checked]="serviceList.includes('MT')" />
                  </div>
                  <span>MT</span>
                </div>
                <div class="d-flex justify-content-start align-items-center gap-10 my-10 cp" (click)="onChangeProducts('MO')">
                  <div class="input-check">
                    <input type="checkbox" class="form-check-input" [checked]="serviceList.includes('MO')" />
                  </div>
                  <span>MO</span>
                </div>
                <div class="d-flex justify-content-start align-items-center gap-10 my-10 cp" (click)="onChangeProducts('VOICE')">
                  <div class="input-check">
                    <input type="checkbox" class="form-check-input" [checked]="serviceList.includes('VOICE')" />
                  </div>
                  <span>CLI</span>
                </div>
                <!-- <div class="d-flex justify-content-start align-items-center gap-10 my-10 cp" (click)="onChangeProducts('ANALYTICS')">
                                    <div class="input-check">
                                        <input type="checkbox" class="form-check-input" [checked]="serviceList.includes('ANALYTICS')" />
                                    </div>
                                    <span>Analytics</span>
                                </div> -->
              </div>
            </div>

            <div *ngIf="filter.filterKey === 'enabled'" class="dropdown-menu px-0 py-0_8 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="fiter-{{ filter.filterKey }}">
              <div class="mx-10">
                <div class="d-flex justify-content-start align-items-center gap-10 my-10 cp" (click)="onClickedEnabled()">
                  <div class="input-check">
                    <input type="checkbox" class="form-check-input" [checked]="form.get('enabled')?.value === true" />
                  </div>
                  <span>Enabled</span>
                </div>
                <div class="d-flex justify-content-start align-items-center gap-10 my-10 cp" (click)="onClickDisabled()">
                  <div class="input-check">
                    <input type="checkbox" class="form-check-input" [checked]="form.get('enabled')?.value === false" />
                  </div>
                  <span>Disabled</span>
                </div>
              </div>
            </div>

            <div *ngIf="filter.filterKey === 'scheduledChange'" class="dropdown-menu px-0 py-0_8 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="fiter-{{ filter.filterKey }}">
              <div class="mx-10">
                <div class="d-flex justify-content-start align-items-center gap-10 my-10 cp" (click)="onNewPricingScheduleChange(true)">
                  <div class="input-check">
                    <input type="checkbox" class="form-check-input" [checked]="form.get('scheduledChange')?.value === true" />
                  </div>
                  <span>Yes</span>
                </div>
                <div class="d-flex justify-content-start align-items-center gap-10 my-10 cp" (click)="onNewPricingScheduleChange(false)">
                  <div class="input-check">
                    <input type="checkbox" class="form-check-input" [checked]="form.get('scheduledChange')?.value === false" />
                  </div>
                  <span>No</span>
                </div>
              </div>
            </div>

          </form>

        </div>
      </div>
    </div>
    <div class="filter-add-btn" *ngIf="shouldAddFilterBeShown()">
      <a role="button" id="add-filter-link" data-bs-toggle="dropdown" aria-expanded="false"><span class="icon-add"></span> Add Filter</a>
      <ul class="dropdown-menu px-0 py-0_8 rounded-15 bg-neutral-n1" attr.aria-labelledby="add-filter-link">
        <ng-container *ngFor="let filter of filters">
          <li *ngIf="!filter.show" class="dropdown-item filter-item px-15 py-10" (click)="onAdditionalFilterClick(filter)">
            <a>{{ filter.title }}</a>
          </li>
        </ng-container>
      </ul>
    </div>

    <div class="v-line"></div>

    <div cdkDropList #deleteArea="cdkDropList" (cdkDropListDropped)="deleteItem($event)">
      <div class="delete-area d-flex justify-content-center align-items-center" (click)="onClearAllFilter()" [ngClass]="{'drag-active': isBeingDragged}">
        <span class="far fa-trash-alt"></span>
        {{isBeingDragged ? 'Remove Filter' : 'Clear Filters'}}
      </div>
    </div>
  </div>

</div>
